import React, { useRef, useState } from "react";

import Loader from "../../../components/Common/Loader";
import { useHistory } from "react-router-dom"
import { InventoryTab, inventoryTabTarget } from './inventoryTabNavigation';
import useInventoryCart from "../Hooks/useInventoryCart";
import { InventoryItemCart } from "../Shared/InventoryItemCart";
import MedicationDispenseForm from "../Shared/MedicationDispenseForm";
import { canClearSelection } from "../Shared/inventoryFormRules";
import { moveCartActionsStyle, moveCartPanelStyle, moveCartScrollStyle } from "../Shared/moveCartLayout";
import { Tooltip } from "../../../components/Utils/Tooltips";
import { Remove } from "../../../components/Icons/Icons";
import { useTranslation } from "react-i18next";
import { DestinationType, MoveTypes } from "../../../api/Inventory/Entities/InventoryMovementEntities";
import { AssignmentType } from "../../../api/Inventory/Entities/InventoryEntities";
import AutoCompletation from "../../../components/Common/AutoCompletation";
import { searchPatients } from "../../../api/database";
import useOperationConfirmation from "../Hooks/useOperationConfirmation";
import { useUnsavedChangesPrompt } from "../../../components/Navigation/useUnsavedChangesPrompt";

export default function PharmacyDispenseRequestPage() {
    const { t } = useTranslation();
    const history = useHistory();
    const [move, isMoveLoading, actions] = useInventoryCart(0, MoveTypes.PharmacyDispenseRequest.Name, AssignmentType.General.Name, null, null, null, { persistDraft: true, history })
    const [Modal, modalActions] = useOperationConfirmation();
    const [selectedPatient, setSelectedPatient] = useState(null)
    const patientRef = useRef(null)
    const { confirmLeave, allowNavigation } = useUnsavedChangesPrompt(move.items.length > 0, history, actions.DiscardDraft)

    function handleNewItem(item) {
        actions.AddItem(item.item, item.release, item.quantity, item.assignment, item.availableQuantity)
    }

    function onDeleteItem(item, _) {
        actions.RemoveItem(item)
    }

    function handleItemChange(quantity, item) {
        actions.UpdateQuantity(item, quantity)
    }

    function onHandleCancel() {
        if (!confirmLeave()) return
        history.push(inventoryTabTarget(InventoryTab.pharmacy))
    }

    async function onHandleSubmit() {
        await modalActions.saveDispenseAsPeding({
            patient: selectedPatient,
            destinationType: DestinationType.PharmacyPatient,
            visitDate: null,
            move: move,
            succeededCallback: () => { allowNavigation(); history.push(inventoryTabTarget(InventoryTab.pharmacy)) }
        })
    }

    const fetchPatients = async (term) => {
        const result = (await searchPatients(term))
            .data

        return result;
    }

    const curringSelected = (callback) => {
        return (selected) => {
            if (selected != null && selected.length > 0) callback(selected[0])
            else callback(null)
        }
    }

    const clearPatient = () => {
        setSelectedPatient(null)
        patientRef.current.clear()
    }

    const isPatientClearable = canClearSelection({ hasSelection: selectedPatient != null, cartItemCount: move.items.length })

    return (<>
        <Loader isLoading={isMoveLoading}>
            <div className='max-width-1500 margin-center'>
                <div className='container-fluid form-container' style={{ fontWeight: "bolder" }}>
                    <h5><strong>{t('inventory.dispense.pharmacyDispenseTitle')}</strong></h5>
                </div>
                <div className='container-fluid form-container'>
                    <div className='right-side' style={{ height: 'max-content', width: '35%' }}>
                        <div style={{ display: 'flex', gap: "1rem", marginBottom: '1rem' }}>
                            <div style={{ width: '100%' }}>
                                <AutoCompletation
                                    id={'Paciente'}
                                    ref={patientRef}
                                    labelKey={(option) => {
                                        return `${option.fullName} (${option.medicalRecordNumber})`;
                                    }}
                                    placeholder={t('commons.patient')}
                                    disabled={selectedPatient != null}
                                    fetchOptions={fetchPatients}
                                    onChange={curringSelected(setSelectedPatient)}
                                />
                            </div>
                            <div>
                                <button type="button" className="btn btn-danger" disabled={!isPatientClearable} onClick={clearPatient}>
                                    <Tooltip tooltip={t('commons.clear')} id={"tooltipedit-limpiarpaciente"}>
                                        <span aria-hidden="true"><Remove /></span>
                                    </Tooltip>
                                </button>
                            </div>
                        </div>
                        <hr />

                        <MedicationDispenseForm assignmentType={AssignmentType.General} handleSubmit={handleNewItem} disabled={selectedPatient == null} />
                    </div>
                    <div className='left-side' style={moveCartPanelStyle}>
                        <div style={moveCartScrollStyle}>
                            <InventoryItemCart items={move.items} onDeleteItem={onDeleteItem} onItemsChange={handleItemChange} showLotNumber={false} showExpirationWarning={false} />
                        </div>
                        <div style={moveCartActionsStyle}>
                            <button type="button" className='btn btn-secondary ml-1' style={{ marginRight: '1rem' }} onClick={onHandleCancel}>{t('buttons.cancel')}</button>
                            <button type="button" className='btn btn-success' disabled={!(move.items.length > 0)} onClick={onHandleSubmit}>{t('buttons.finish')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </Loader>
        <Modal />
    </>
    )
}